/* ===== CATI Pakistan — GSAP Animations Suite ===== */
import { gsap } from 'gsap';

export function initGsapAnimations() {
  // Check if reduced motion is requested
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  // 1. Hero Content Entrance Animation
  const heroTitle = document.querySelector('.hero__title');
  const heroSubtitle = document.querySelector('.hero__subtitle');
  const heroCtas = document.querySelector('.hero__actions');

  if (heroTitle) {
    gsap.fromTo(
      heroTitle,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 1, ease: 'power3.out' }
    );
  }
  if (heroSubtitle) {
    gsap.fromTo(
      heroSubtitle,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 1, delay: 0.2, ease: 'power3.out' }
    );
  }
  if (heroCtas) {
    gsap.fromTo(
      heroCtas,
      { opacity: 0, y: 15 },
      { opacity: 1, y: 0, duration: 0.8, delay: 0.4, ease: 'power3.out' }
    );
  }

  // 2. Animated Stats Counter (GSAP Tweening)
  const statNumbers = document.querySelectorAll('.stat__number[data-value]');
  statNumbers.forEach((el) => {
    const target = parseInt(el.getAttribute('data-value'), 10) || 0;
    const obj = { val: 0 };
    
    gsap.to(obj, {
      val: target,
      duration: 2,
      ease: 'power2.out',
      onUpdate: () => {
        el.textContent = Math.floor(obj.val);
      }
    });
  });

  // 3. Image Hover Micro-interactions
  document.querySelectorAll('.img-zoom img').forEach((img) => {
    img.addEventListener('mouseenter', () => {
      gsap.to(img, { scale: 1.06, duration: 0.4, ease: 'power2.out' });
    });
    img.addEventListener('mouseleave', () => {
      gsap.to(img, { scale: 1.0, duration: 0.4, ease: 'power2.out' });
    });
  });
}
